<div class="mb-4">
  <div class="flex">
    <div
      *ngFor="let tab of tabs"
      (click)="setActiveTab(tab.id)"
      [ngClass]="{
        'bg-neutral-gray20': tab.isActive,
        'bg-white': !tab.isActive
      }"
      class="mr-2 cursor-pointer rounded-lg p-2.5 text-base font-medium text-neutral-gray70">
      {{ tab.label | translate }}
      <span *ngIf="tab.isComingSoon" class="ml-2 text-xs text-neutral-gray40">
        ( {{ 'modules.profile_settings.subscription.coming_soon' | translate }} )
      </span>
    </div>
  </div>
</div>
